import styled from 'styled-components';

export const StyledMedicalLeaveErrorsStatus = styled.div`
   width: 100%;
`;
